export default "__VITE_ASSET__wcPkXoza__"